
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { isMobile } from '@/utils/validate';
import defaultLogo from '@/assets/image/common/logo.png';
import geaLogo from '@/assets/image/common/logo-gea.png';
@Component({
  name: 'FooterNav',
  components: {
  },
})
export default class extends Vue {
  get isMobile() {
    return isMobile();
  }
  get langEN() {
    if (AppModule.language === 'en-us') {
        return true;
    } else {
        return false;
    }
  }
  get langCN() {
      if (AppModule.language === 'zh') {
          return true;
      } else {
          return false;
      }
  }
  get routes() {
    return (this.$router as any).options.routes.filter((item: any) => item.meta.hidden === false);
  }
  get currentCompany() {
    const { company } = this.$route.query;
    return Array.isArray(company) ? company[0] || '' : company || '';
  }
  get logoSrc() {
    return this.currentCompany.toLowerCase() === 'gea' ? geaLogo : defaultLogo;
  }
  get companyNameText() {
    return this.currentCompany.toLowerCase() === 'gea'
      ? this.$t('index.companyName1').toString()
      : this.$t('index.companyName').toString();
  }
  get companyAddressText() {
    return this.currentCompany.toLowerCase() === 'gea'
      ? this.$t('index.companyAddress2').toString()
      : this.$t('index.companyAddress').toString();
  }
  get companyPhoneText() {
    return this.currentCompany.toLowerCase() === 'gea'
      ? this.$t('index.companyPhone2').toString()
      : this.$t('index.companyPhone').toString();
  }
  public handleMenu(item: any) {
    this.navigateTo({
      path: item.path,
      query: this.currentCompany ? { company: this.currentCompany } : {},
    });
  }
  private navigateTo(target: any) {
    const { route } = this.$router.resolve(target);
    if (route.fullPath === this.$route.fullPath) {
      return;
    }
    this.$router.push(target).catch((err) => err);
  }
}
